function isObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isLocalRef(value) {
  return value.startsWith("#");
}
function keyOf(value) {
  return Object.keys(value);
}
const deepClone = (value) => {
  return JSON.parse(JSON.stringify(value));
};
const split = (array, condition) => {
  return array.reduce(
    ([pass, fail], item) => {
      return condition(item) ? [[...pass, item], fail] : [pass, [...fail, item]];
    },
    [[], []]
  );
};
const safeAssign = (target, source) => {
  Object.assign(target, source);
};
export {
  deepClone,
  isLocalRef,
  isObject,
  keyOf,
  safeAssign,
  split
};
//# sourceMappingURL=general.js.map
